import { Injectable } from '@angular/core';
import { AutomationCredentialsService } from './automation-credentials.service';

@Injectable()
export class AutomationMapFormatTransformService {

  constructor(private automationCredentialsService: AutomationCredentialsService) { }

  getExecutionContextDefaultCopy(inputMap,
    outputMap,
    accessKeyId,
    secretAccessKey){
    let copy = Object.assign({}, this._executionContextDefault);

    this._updateMFTInputMap(copy, inputMap);
    this._updateMFTOutputMap(copy, outputMap);
    this.automationCredentialsService.updateCredentialsS3(copy, accessKeyId, secretAccessKey);

    return copy;
  }
  private _updateMFTInputMap(executionContext, argumentValue){
    executionContext.WorkItem.Arguments.InputArguments.forEach(argument => {
        if(argument.Name === "MapIn"){
            argument.Resource = argumentValue;
        }
    });
  }
  private _updateMFTOutputMap(executionContext, argumentValue){
    executionContext.WorkItem.Arguments.OutputArguments.forEach(argument => {
        if(argument.Name === "MapOut"){
            argument.Resource = argumentValue;
        }
    });
  }
  private _executionContextDefault = {
    "WorkItem": {
        "Id": "MapFormatTransformWorkItem",
        "ActivityId": "MapFormatTransformActivity",
        "Arguments": {
                "InputArguments": [{
                "Resource": "https://iohsbsharebucket.s3.amazonaws.com/MapTransform/mapIn/hsbExporter.dxx",
                "Name": "MapIn",
                "StorageProvider": "S3",
                "Headers":[{
                  "Name":"AccessKeyId",
                  "Value":"AKIAIMVKNEIZGS4LP7KQ"
                },{
                    "Name":"SecretAccessKey",
                    "Value":"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"
                }]
            }],
            "OutputArguments": [{
                "Resource": "https://iohsbsharebucket.s3.amazonaws.com/MapTransform/mapOut/hsbExporter.hmm",
                "Name": "MapOut",
                "StorageProvider": "S3",
                "Headers":[{
                  "Name":"AccessKeyId",
                  "Value":"AKIAIMVKNEIZGS4LP7KQ"
                },{
                    "Name":"SecretAccessKey",
                    "Value":"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"
                }]                      
            }]
        }
    },
    "Activity": {
        "ActivityId": "MapFormatTransformActivity",
        "HostApplication": "$(__applicationsRoot)/Development/MapFormatTransform/MapFormatTransform.exe",
        "Parameters": {
            "InputParameters": [{
                "Name": "MapIn",
                "LocalFolderPath": "$(__downloadFolder)",
                "LocalFileName": "hsbExporter.dxx"
            }],
            "OutputParameters": [{
                "Name": "MapOut",
                "LocalFolderPath": "$(__downloadFolder)",
                "LocalFileName": "hsbExporter.hmm"
            }]
        },
        "Instruction": {
            "CommandLineParameters": ["$(MapIn)", "$(MapOut)"],
        },
    },
  };

}



// WEBPACK FOOTER //
// ./src/app/automation-map-format-transform.service.ts